import { Box, Stack, Typography } from 'ui';
import { MenuBook } from 'ui/icons';

export const StepFour = () => {
  return (
    <Stack alignItems="center" gap={2}>
      <Box display="flex" alignItems="center" gap={1}>
        <Typography fontWeight="bold">Help guide</Typography>
        <MenuBook />
      </Box>

      <Typography textAlign="center">
        More information about how to take great photos for the AI analysis can be found via the help guide option.
      </Typography>
    </Stack>
  );
};
